// TODO: Get typed State
const getUserFullName = (state: any): string => {
  const { models: { me: { firstName = '', lastName = '' } } } = state

  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  }

  if (!firstName && !lastName) {
    return `Scentbird Account`
  }

  return firstName || lastName
}


export default getUserFullName
